import React, { useState, useEffect, useRef } from 'react'
import { BackArrowFeed, InfoIconBranding, CalendarChallengeIcon, LocationChallengeIcon, PeopleChallengeIcon, RewardsChallengeIcon, WellnessGalIcon, /*WatchIcon, CompleteTaskIcon, AudioIcon,*/  ProgressTickIcon } from '../../../utils/icons'
import PropTypes from 'prop-types';
import { BadgeEarned, BottomContainer, ChallengeDetailsConatainer, ChallengeHeading, ChallengesContainer, ColorBox, DateLocationContainer, ImageLayout, LevelConatiner, PointsContainer, RightContainer } from '../../UserDashboard/styles';
// import Calendar from 'react-calendar';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { commaSeperator, convertDateInTimezone, convertMonthFromDate,/* convertMonthFromDate, */fetchApi } from '../../../utils/methods';
import { toast } from 'react-toastify';
import { GetWellnessChallengeDetails } from '../../../redux/constants/apiConstants';
import { useParams } from 'react-router-dom';
import moment from 'moment';
// import { useLocation } from "react-router-dom";
import SkeletonLoder from '../../common/skeletonLoder';
// import { CalendarPicker, CalendarWrapper } from '../../LogWorkoutCategoryV3/styles';
import { Border } from '../../RecogntionAdmin/styles';
import { ImageUrl } from '../../../utils/constants';
import { TabViewNew } from '../styles';
import { ProgressBar, ProgressCircleWrapper, ProgressText } from '../styles';
import { CheckBoxContainer, GoalCardContainer, ShowLessContent, ShowLessMoreTextContainer, TaskContainer, TextContainer } from './styles';
import JournalDetailsPage from './JournalDetailsPage';
import { CommonButtonPopup } from '../../ReportsV2/styles';
import { CommonButtonBorder } from '../../common/commonStyles';
// import { Task } from '../../InputGoalsV2/styles';
import FeelingModal from './FeelingModal';
import PreQuizModal from '../../UserDashboard/PreQuizModal';
import QuizDetails from './QuizDetails';
import ChallengeCompleteModal from './ChallengeCompleteModal';
import parse from 'react-html-parser';
import AudioPlayer from '../../common/AudioPlayer/AudioPlayer';
import dayjs from 'dayjs';


function UserWellnessChallenge({ history }) {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState(
    history?.location?.state?.activeTab || "Challenge"
  );
  // const [activeTab, setActiveTab] = useState("Challenge");
  const [selectedDate, setSelectedDate] = useState(null);
  const [wellnessChallengeDetails, setWellnessChallengeDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [openFeelingModal, setOpenFeelingModal] = useState(false);
  // const location = useLocation();
  // const isCompletedTab = location?.state?.completedTab;
  // const [isCompletedChallenge, setIsCompletedChallenge] = useState(isCompletedTab || false);
  const [isCompletedChallenge, setIsCompletedChallenge] = useState(false);
  const [showPostQuiz, setShowPostQuiz] = useState(false);
  const [showBadgePopup, setShowBadgePopup] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  // const[selectedtask,setSelectedTask] = useState(false);
  // const [showMore,setShowmore]= useState(false);

  const textRef = useRef(null);
  const isToday = selectedDate
    ? moment(selectedDate).isSame(moment(), "day")
    : false;

  // useEffect(() => {
  //   if (textRef.current) {
  //     const element = textRef.current;

  //     setShowToggle(
  //       element.scrollHeight > element.clientHeight
  //     );
  //   }
  // }, [selectedTask, isExpanded]);


  // useEffect(() => {
  //   if (textRef.current) {
  //     const element = textRef.current;

  //     const lineHeight = parseFloat(
  //       window.getComputedStyle(element).lineHeight
  //     );

  //     const maxCollapsedHeight = lineHeight * 2;

  //   }
  // }, [selectedTask]);


  // useEffect(() => {
  //   if (isToday) {
  //     setIsExpanded(true); // today's task full text
  //   } else {
  //     setIsExpanded(false); // past task collapsed
  //   }
  // }, [selectedDate, isToday]);

  useEffect(() => {
    setIsExpanded(isToday);
  }, [selectedDate]);

  useEffect(() => {

    if (id) {
      FetchWellnessChallenegesData(id);
    }
  }, [id])

  const handleMediaComplete = () => {
    if (isToday && !selectedTask?.is_completed) {
      setOpenFeelingModal(true);
    }
  };

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  const closeQuizModal = () => {
    setShowPostQuiz(false);
    FetchWellnessChallenegesData(id); // refresh data to get updated quiz status
  };

  // useEffect(() => {
  //   if (!showPostQuiz && isCompletedChallenge) {
  //     const hasSubmittedPostQuiz =
  //       wellnessChallengeDetails?.user_progress?.has_submitted_post_quiz;

  //     if (hasSubmittedPostQuiz === 1) {
  //       setShowBadgePopup(true);
  //     }
  //   }
  // }, [showPostQuiz, wellnessChallengeDetails, isCompletedChallenge]);



  const FetchWellnessChallenegesData = async (challengeId) => {
    setIsLoading(true);
    try {
      const res = await fetchApi(GetWellnessChallengeDetails + "/" + challengeId, "GET");
      if (res.status === 'success') {
        setWellnessChallengeDetails(res.data);

        const challengeStatus = res?.data?.challenge_info?.challenge_status;
        const hasSubmittedPostQuiz = res?.data?.user_progress?.has_submitted_post_quiz;
        const showPostQuizFlag = res?.data?.challenge_info?.show_post_quiz;

        const isCompleted = challengeStatus === "completed";

        setIsCompletedChallenge(isCompleted);


        // ✅ YOUR MAIN LOGIC
        // if (isCompleted) {
        //   if (hasSubmittedPostQuiz === 0 || hasSubmittedPostQuiz === null  ) {
        //     const showPostQuizFlag = res?.data?.challenge_info?.show_post_quiz;

        //     setShowPostQuiz(showPostQuizFlag === true);
        //     // setShowPostQuiz(true);   // 👉 show post quiz
        //   } 
        //   // else if (hasSubmittedPostQuiz === 1 ) {
        //   //   setShowBadgePopup(true); // 👉 show badge
        //   // }
        // }


        // if (
        //   isCompleted &&
        //   showPostQuizFlag &&
        //   (hasSubmittedPostQuiz === 0 || hasSubmittedPostQuiz === null)
        // ) {
        //   setShowPostQuiz(true);
        // } else {
        //   setShowPostQuiz(false);
        // }


        if (isCompleted) {
          if (showPostQuizFlag) {
            // Quiz exists
            if (hasSubmittedPostQuiz === 0 || hasSubmittedPostQuiz === null) {
              setShowPostQuiz(true);     // 👉 Show quiz first
              setShowBadgePopup(false);
            } else {
              setShowPostQuiz(false);
              setShowBadgePopup(true);   // 👉 Quiz done → show badge
            }
          } else {
            setShowPostQuiz(false);
            setShowBadgePopup(true);
          }
        } else {
          setShowPostQuiz(false);
          setShowBadgePopup(false);
        }



        const start = moment(res.data.challenge_info.challenge_started_at);
        const end = moment(res.data.challenge_info.challenge_end_at);
        const today = moment();

        let defaultDate;

        if (today.isBetween(start, end, "day", "[]")) {
          defaultDate = today.toDate();
        } else {
          defaultDate = start.toDate();
        }

        setSelectedDate(defaultDate);
        // setSelectedTask(today_task)
        // if (res.data?.start_date && isCompletedTab) {
        //   const firstDay = moment(res.data.start_date).toDate();
        //   setSelectedDate(firstDay);
        // }
        // else{
        //   const today = new Date();
        //   setSelectedDate(today);
        // }

      } else {
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
    finally {
      setIsLoading(false);
    }
  }

  const getSelectedTask = () => {
    if (!selectedDate || !wellnessChallengeDetails) return null;

    const selected = moment(selectedDate).format("YYYY-MM-DD");

    const dayData = wellnessChallengeDetails.daily_progress_tracking.find(
      (d) => moment(d.date).format("YYYY-MM-DD") === selected
    );

    if (!dayData) return null;

    const task = wellnessChallengeDetails.all_tasks.find(
      (t) => t.task_id === dayData.task_id
    );

    return { ...task, ...dayData };
  };

  const popover = () => (
    <Popover
      id="points-popover"
      className="custom-popover"
    >
      <Popover.Body>
        Thanks for joining. You’ll receive your points <br />
        at the end of the challenge.
      </Popover.Body>
    </Popover>
  );



  const Attendees = () => {
    window.console.log("")
    return (
      <div className="rewardBox">
        {PeopleChallengeIcon()}
        <div className="rewardValue">
          {commaSeperator(wellnessChallengeDetails?.total_participants_count)} Attendees
        </div>
      </div>
    )
  }

  const today = moment().startOf("day");
  const endDate = moment(
    convertDateInTimezone(
      wellnessChallengeDetails?.challenge_info?.challenge_end_at
    )
  ).startOf("day");

  const remainingDays = endDate.diff(today, "days") + 1;

  const renderLeftContainer = () => (


    <div className="leftContainer">
      <ChallengeHeading>
        {wellnessChallengeDetails?.challenge_info?.title}
      </ChallengeHeading>
      <ImageLayout>
        <img src={ImageUrl + "/" + wellnessChallengeDetails?.challenge_info?.image} alt="Challenge banner" />
      </ImageLayout>
      <Border margin={"20px 0 "} background={'#EFEFEF'} height={'0.75px'} />
      <div className="AboutHeading">About the challenge</div>
      <div className="des" style={{ margin: "12px 0 0 0" }}>
        {parse(wellnessChallengeDetails?.challenge_info?.description)}
      </div>
      <Border margin={"20px 0 "} background={'#EFEFEF'} height={'0.75px'} />
      <DateLocationContainer>
        <div className="insideBox">
          {CalendarChallengeIcon()}
          {isCompletedChallenge ? <div className="text">
            Ended on  {convertMonthFromDate(
              moment(convertDateInTimezone(wellnessChallengeDetails?.challenge_info?.challenge_end_at)).format("MMMM D, YYYY")
            )}
          </div> : <div className="text">
            {/* {convertMonthFromDate(
              moment(convertDateInTimezone(wellnessChallengeDetails?.challenge_info?.challenge_started_at)).format("MMMM D")
            )} - {convertMonthFromDate(
              moment(convertDateInTimezone(wellnessChallengeDetails?.challenge_info?.challenge_end_at)).format("MMMM D, YYYY")
            )} */}
            {remainingDays === 0
              ? "Ends Today"
              : `Ends in ${remainingDays} Day${remainingDays > 1 ? "s" : ""}`}
          </div>}
        </div>
        <div className="insideBox">
          {LocationChallengeIcon()}
          <div className="text">{wellnessChallengeDetails?.location}</div>
        </div>
      </DateLocationContainer>


      <div style={{ display: "flex" }}>
        {/* Reward Info */}
        {isCompletedChallenge && wellnessChallengeDetails?.points_earned_so_far ? (
          <div className="rewardBox">
            {RewardsChallengeIcon()}
            <div className="rewardHeading">
              You Earned +{wellnessChallengeDetails?.points_earned_so_far} XP
            </div>
          </div>
        ) : !isCompletedChallenge ? (
          <div className="rewardBox">
            {RewardsChallengeIcon()}
            <div className="rewardValue">
              {wellnessChallengeDetails?.challenge_info?.points} XP per Day On Task Completion
            </div>
          </div>
        ) : null}

        {/* Attendees always visible */}
        {wellnessChallengeDetails?.total_participants_count ? <Attendees /> : null}
      </div>

      {isCompletedChallenge && wellnessChallengeDetails?.challenge_achievement?.challenge_completed_per >= 80 ? <BadgeEarned>
        <img className="badgeIcon" src={`${ImageUrl}/${wellnessChallengeDetails?.challenge_achievement?.challenge_badge}`} alt="" />
        {/* <div>{wellnessChallengeDetails?.challenge_achievement?.challenge_badge}</div> */}
        <TextContainer isFontSize={"18px"} isLineHeight={"24px"} isFontWeight={"700"}>Badge Earned</TextContainer>
      </BadgeEarned> : null}

    </div>
  );

  //   const selectedDayData = getSelectedDateData();
  //   const selectedDayTotal = selectedDayData?.total || 0;
  //   const formattedActivityType =
  //   ActivityType?.charAt(0).toUpperCase() + ActivityType?.slice(1);

  const selectedTask = getSelectedTask();

  const renderRightContainer = () => (
    <div>
      <RightContainer isAlignment={"flex-start"}>
        <TextContainer isMargin={"0 0 20px 0"}>{isToday ? "Today’s Goal" : `${moment(selectedDate).format("MMMM DD, YYYY")} - Goal`} </TextContainer>
        <GoalCardContainer>
          {/* <div className="myGoalHeading">My Goal</div> */}
          {/* <div className="goalText">{wellnessChallengeDetails?.challenge_info?.goal}</div> */}
          <div className="goalText">{selectedTask?.task_goal}</div>

          <div className="goalIcon">{WellnessGalIcon()}</div>
        </GoalCardContainer>
        <TextContainer isMargin={"0 0 20px 0"}>
          {isToday ? " Today’s Task" : `${moment(selectedDate).format("MMMM DD, YYYY")} - Task`}
          {/* {isToday && " Today’s Task"} */}
        </TextContainer>
        <TaskContainer onClick={handleToggle}>
          <CheckBoxContainer isCursor={"default"} /*selected={selectedWellbeingPillars.includes(pillar.id) ? true : false} */>
            <div className="selection">
              {selectedTask?.is_completed ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  {ProgressTickIcon("#DA6C74")}
                </div>
              ) : (
                null
              )}
            </div>
          </CheckBoxContainer>
          <div className="taskHeading">
            <ShowLessMoreTextContainer ref={textRef} isExpanded={isExpanded} isTextColor={"#184A61"}>
              {selectedTask?.task}
              {/* Walk through your home and workspace today with fresh eyes. In each space, identify three things that connect you to nature — a plant, natural light, a window view — and three things that disconnect you — plastic clutter, artificial air, noise. Write them all down. Walk through your home and workspace today with fresh eyes. In each space, identify three things that connect you to nature — a plant, natural light, a window view — and three things that disconnect you — plastic clutter, artificial air, noise. Write them all down. Walk through your home and workspace today with fresh eyes. In each */}
            </ShowLessMoreTextContainer>

            <ShowLessContent>
              {isExpanded ? "Show Less" : "Show More"}
            </ShowLessContent>

            {/* <ShowLessContent>  {isExpanded ? "Show Less" : "Show More"}</ShowLessContent> */}
            {/* <div className="completionContainer">
              {selectedTask?.media_type === "mp4" && ( 
                <>
                  <div>{WatchIcon()}</div>
                  <TextContainer isTextColor={"#FEFEFE"}>Watch Video</TextContainer>
                </>)}
              {selectedTask?.media_type === "mp3" && (
                <>
                  <div>{AudioIcon()}</div>
                  <TextContainer isTextColor={"#FEFEFE"}>Listen Audio</TextContainer>
                </>
              )}
              {selectedTask?.media_type === "yes-no" && (
                <>
                  <div>{CompleteTaskIcon()}</div>
                  <TextContainer isTextColor={"#FEFEFE"}>Complete Your Task</TextContainer>
                </>
              )}
            </div> */}
          </div>
        </TaskContainer>


        {selectedTask?.media_type === "mp3" && (<AudioPlayer
          src={selectedTask?.media_link?.startsWith("http") ? selectedTask?.media_link : ImageUrl + "/" + selectedTask?.media_link}
          title="audio"
          margin={"20px 0px"}
          onComplete={handleMediaComplete}
          showListenText={false}
          showVolume={false}
        />
        )}

        {selectedTask?.media_type === "mp4" && (
          <CommonButtonBorder
            width={"420px"}
            height={"44px"}
            margin={"0 0 20px 0"}
            onClick={() =>
              history.push({
                pathname: "/challenges/wellness-challenge-player",
                state: {
                  media_link: selectedTask?.media_link,
                  media_type: selectedTask?.media_type,
                  media_thumbnail: selectedTask?.media_thumbnail,
                  title: selectedTask?.task,
                  taskId: selectedTask?.task_id,
                  challengeId: id,
                  isToday: isToday,
                  isCompleted: selectedTask?.is_completed
                },
              })
            }>
            Watch Video
          </CommonButtonBorder>
        )}

        {selectedTask?.media_type === "mp3" && (
          <CommonButtonBorder
            width={"420px"}
            height={"44px"}
            margin={"0 0 20px 0"}
            onClick={() =>
              history.push({
                pathname: "/challenges/wellness-challenge-player",
                state: {
                  media_link: selectedTask?.media_link,
                  media_type: selectedTask?.media_type,
                  media_thumbnail: selectedTask?.media_thumbnail,
                  title: selectedTask?.task,
                  taskId: selectedTask?.task_id,
                  challengeId: id,
                  isToday: isToday,
                  isCompleted: selectedTask?.is_completed
                },
              })
            }>
            Listen Audio
          </CommonButtonBorder>
        )}




        {isToday && selectedTask?.media_type === "yes-no" && selectedTask?.is_completed === 0 ? (
          <>
            <TextContainer isMargin={"0 0 12px 0"}>Did you complete today’s task?</TextContainer>

            <div style={{ display: "flex", gap: "12px", marginBottom: "20px" }}>
              <CommonButtonPopup width={"204px"} height={"40px"} onClick={() => {
                setOpenFeelingModal(true);
              }}>
                Yes
              </CommonButtonPopup>

              <CommonButtonBorder width={"204px"} height={"40px"}
                onClick={() => {
                  setOpenFeelingModal(true);
                }}>
                No
              </CommonButtonBorder>
            </div>
          </>
        ) : null}


        {/* <LevelConatiner style={{ position: "relative" }} isPadding={"8px 16px 0px 16px"}>
          <div className="dateContainer">
            {moment(selectedDate).format("MMM DD, YYYY")}</div>
        </LevelConatiner> */}
        <LevelConatiner style={{ display: "block" }}>
          {/* <CalendarView /> */}
          {CalendarViewV1()}
          <BottomContainer isWidthSize={"225px"}>
            <div className="secondRow seconRowMargin">
              <div className="rowContennt">
                <ColorBox />
                <div className="textBox">Completed</div>
              </div>
              <div className="rowContennt">
                <ColorBox isColor="#FDD2CB" />
                <div className="textBoxForNC">Not Completed</div>
              </div>
              {/* <div className="rowContennt">
                <ColorBox isColor="#DCDCDC" />
                <div className="textBox">NA</div>
              </div> */}
            </div>
          </BottomContainer>

        </LevelConatiner>

        <LevelConatiner>
          <img className="levelImage" src={ImageUrl + "/" + wellnessChallengeDetails?.icon}></img>
          <div className="levelName">{wellnessChallengeDetails?.level_name} Level</div>
        </LevelConatiner>
        <PointsContainer>
          <div className="pointeSection">
            <div className="heading">{isCompletedChallenge ? "Total Points Earned - " : "Points earned so far - "} <span className="pointValue">{wellnessChallengeDetails?.points_earned_so_far}XP</span></div>
            {isCompletedChallenge ? null : <OverlayTrigger placement="bottom" overlay={popover()} containerPadding={10}
              popperConfig={{ strategy: 'fixed' }}>
              <div className="icon">{InfoIconBranding()}</div>
            </OverlayTrigger>}
          </div>
        </PointsContainer>
      </RightContainer>
    </div>

  );



  // const CalendarView = () => {
  //   // const isFutureDate = (date) => {
  //   //   window.console.log("")
  //   //   return moment(date).isAfter(moment(), "day");
  //   // };

  //   // const isSameDay = (date1, date2) => {
  //   //   window.console.log("")
  //   //   return moment(date1).isSame(moment(date2), "day");
  //   // };

  //   // const getCalendarStatus = (date) => {
  //   //   window.console.log("")
  //   //   return wellnessChallengeDetails?.calendar?.find((item) =>
  //   //     moment(item.date).isSame(moment(date), "day")
  //   //   );
  //   // };

  //   // const startOfMonth = isCompletedTab ? moment(wellnessChallengeDetails?.challenge_started_at).toDate() : moment().startOf("month").toDate();
  //   // const endOfMonth = isCompletedTab ? moment(wellnessChallengeDetails?.challenge_end_at).toDate() : moment().endOf("month").toDate();

  //   const startDate = moment(wellnessChallengeDetails?.challenge_info?.challenge_started_at).toDate();
  //   const endDate = moment(wellnessChallengeDetails?.challenge_info?.challenge_end_at).toDate();

  //   const isOutsideRange = (date) => {
  //     window.console.log("")
  //     return (
  //       moment(date).isBefore(startDate, "day") ||
  //       moment(date).isAfter(endDate, "day")
  //     );
  //   };


  //   return (
  //     <CalendarWrapper>
  //       <CalendarPicker>
  //         <TaskCalendar>
  //           <Calendar
  //             value={selectedDate}
  //             onChange={setSelectedDate}
  //             prevLabel={null}
  //             minDate={startDate}
  //             maxDate={endDate}
  //             nextLabel={null}
  //             prev2Label={null}
  //             navigationLabel={null}
  //             next2Label={null}
  //             formatShortWeekday={(locale, date) =>
  //               date.toLocaleDateString(locale, { weekday: "short" }).slice(0, 2)
  //             }
  //             /* 🎨 COLORS */
  //             tileClassName={({ date, view }) => {
  //               if (view !== "month") return null;

  //               const isOutside =
  //                 moment(date).isBefore(startDate, "day") ||
  //                 moment(date).isAfter(endDate, "day");

  //               if (isOutside) return "na"; // 👈 GREY


  //               const today = moment();
  //               // ⚠️ Future BUT inside challenge → light grey (#F8F8F8)
  //               if (moment(date).isAfter(today, "day")) {
  //                 return "future";
  //               }


  //               const status = wellnessChallengeDetails?.daily_progress_tracking.find(
  //                 (d) => moment(d.date).isSame(date, "day")
  //               );

  //               let className = "";

  //               if (status) {
  //                 className = status.is_completed ? "completed" : "missed";
  //               }

  //               if (selectedDate && moment(date).isSame(selectedDate, "day")) {
  //                 className += " selected";
  //               }

  //               return className.trim();
  //             }}

  //             tileDisabled={({ date }) => {
  //               const today = moment();

  //               return (
  //                 isOutsideRange(date) ||
  //                 moment(date).isAfter(today, "day")   // ✅ disable future
  //               );
  //             }}
  //           />
  //         </TaskCalendar>
  //       </CalendarPicker>
  //     </CalendarWrapper>
  //   );
  // }

  const CalendarViewV1 = () => {

    const { daily_progress_tracking } = wellnessChallengeDetails;

    // const startDate = moment(wellnessChallengeDetails?.challenge_info?.challenge_started_at).toDate();
    // const endDate = moment(wellnessChallengeDetails?.challenge_info?.challenge_end_at).toDate();

    // const isOutsideRange = (date) => {
    //   window.console.log("")
    //   return (
    //     moment(date).isBefore(startDate, "day") ||
    //     moment(date).isAfter(endDate, "day")
    //   );
    // };


    return (
      <>

        <div>
          <ProgressText>Daily Progress Tracking</ProgressText>

          <ProgressCircleWrapper gap={'12px 18px'}>
            {daily_progress_tracking?.map((task, index) => {
              const taskDate = dayjs(task.date);
              const currentDate = dayjs();

              const isToday = taskDate.isSame(currentDate, "day");
              const isFutureDay = taskDate.isAfter(currentDate, "day");
              const isCompleted = task.is_completed === 1;

              let backgroundColor, borderColor;

              if (isFutureDay) {
                backgroundColor = "#F8F8F8"; // future
                borderColor = "#DCDCDC";
              } else if (isToday) {
                if (isCompleted) {
                  backgroundColor = "#75B084"; // completed today
                  borderColor = "#DDEEDF";
                } else if (task.completed_at) {
                  backgroundColor = "#FCF2F3"; // today missed
                  borderColor = "#F6D5D6";
                } else {
                  backgroundColor = "#F1F8F2"; // today but not yet completed
                  borderColor = "#DDEEDF";
                }
              } else {
                if (isCompleted) {
                  backgroundColor = "#75B084"; // past completed
                  borderColor = "#DDEEDF";
                } else if (task.completed_at === null) {
                  backgroundColor = "#F8F8F8"; // past completed
                  borderColor = "#FDD2CB";
                } else {
                  backgroundColor = "#FCF2F3"; // past missed
                  borderColor = "#F6D5D6";
                }
              }

              if (dayjs(selectedDate).isSame(taskDate, "day")) {
                backgroundColor = isCompleted ? "#92A4DA" : "#F2F5FB";
                borderColor = isCompleted ? "#E7EEF8" : "#D3DEF2";
              }

              return (
                <div className="progressWrapper" key={task.task_id} title={dayjs(task?.date).format("MMMM, DD YYYY")}>
                  <ProgressBar
                    // isShowMore={showMore}
                    backgroundColor={backgroundColor}
                    borderColor={borderColor}
                    circleHeight={'38.92px'}
                    circleWidth={'38.92px'}
                    onClick={() =>
                      !isFutureDay && setSelectedDate(dayjs(task?.date).toDate())
                    }
                    // onClick={()=>!isFutureDay && setSelectedDate(task?.date)}
                    style={{ cursor: !isFutureDay ? 'pointer' : 'not-allowed' }}
                  >
                    <div className="iconContainer">
                      {isCompleted && ProgressTickIcon("#FFFFFF")}
                    </div>
                  </ProgressBar>
                  <div className="weekLabel">D{index + 1}</div>
                </div>
              );
            })}
          </ProgressCircleWrapper>
        </div>

        {/* {daily_progress_tracking.length > 7 && (
          <div className="showMoreText" onClick={() => setShowmore((prev) => !prev)}>
            {showMore ? "Show Less" : "Show More"}
            <span
              style={{
                display: "flex",
                transition: "transform 0.3s ease",
                transform: showMore ? "rotate(180deg)" : "rotate(0deg)",
                marginLeft: "8px",
              }}
            >
              {ShowMoreArrow()}
            </span>
          </div>
        )} */}
      </>
    );
  }


  return (
    <div style={{ maxWidth: "1246px", padding: "24px 0px 40px 0px", margin: "auto", width: "100%" }}>
      {isLoading ?
        (<SkeletonLoder width={"100%"} height={"700px"} style={{ marginTop: "25px" }} />)
        :
        (<>
          <ChallengesContainer>
            <div className='right-row'>
              <div className="icon"
                onClick={() => {
                  if (isCompletedChallenge) {
                    history.push({
                      pathname: "/challenges/completed",
                      state: { activeSubTab: "monthly" }
                    });
                  } else {
                    history.push("/portal");
                  }
                }}>
                {BackArrowFeed("#DA6C74")}
              </div>
              <TabViewNew
                width
                padding
                margin={"0px 16px 0px 0px"}
                height="40px"
                active={activeTab == "Challenge" ? 1 : 0}
                onClick={() => setActiveTab("Challenge")}
              >
                {"Challenge"}
              </TabViewNew>
              <TabViewNew
                width
                padding
                margin={"0px 16px 0 0"}
                height="40px"
                active={activeTab == "Journal" ? 1 : 0}
                onClick={() => setActiveTab("Journal")}
              >
                {"Journal"}
              </TabViewNew>

              {isCompletedChallenge ? <TabViewNew
                width
                padding
                margin={"0px 16px 0px 0px"}
                height="40px"
                active={activeTab == "Quiz" ? 1 : 0}
                onClick={() => setActiveTab("Quiz")}
              >
                {"Quiz"}
              </TabViewNew> : null}
            </div>

          </ChallengesContainer>

          {activeTab === "Challenge" ? <ChallengeDetailsConatainer>
            <div className="insideConatainer">
              {renderLeftContainer()}
              {renderRightContainer()}
            </div>
          </ChallengeDetailsConatainer> : null}

          {activeTab === "Journal" ? <JournalDetailsPage /> : null}


          {activeTab === "Quiz" ? <QuizDetails /> : null}
        </>
        )}

      {showPostQuiz && <PreQuizModal
        showModal={showPostQuiz} onHide={closeQuizModal} challengeId={id} quizType={'post'} />}

      {/* {showBadgePopup && (
        <ChallengeBadgePopup
          showModal={showBadgePopup}
          badge={wellnessChallengeDetails?.challenge_achievement?.challenge_badge}
          points={wellnessChallengeDetails?.challenge_achievement?.challenge_points}
          onHide={() => setShowBadgePopup(false)}
        />
      )} */}

      {showBadgePopup && (
        <ChallengeCompleteModal
          showModal={showBadgePopup}
          challenge={wellnessChallengeDetails}
          badge={wellnessChallengeDetails?.challenge_achievement?.challenge_badge}
          points={wellnessChallengeDetails?.challenge_achievement?.challenge_points}
          onHide={() => setShowBadgePopup(false)}
        />
      )}

      {openFeelingModal && <FeelingModal completedStatus={!selectedTask?.is_completed} taskId={selectedTask?.task_id} showModal={openFeelingModal} setActiveTab={setActiveTab} onHide={() => setOpenFeelingModal(false)} challengeId={id} onCompleteTask={FetchWellnessChallenegesData} />}

    </div>
  );
}

UserWellnessChallenge.propTypes = {
  history: PropTypes.object.isRequired,
};

export default UserWellnessChallenge;
